import styled from '@emotion/styled';

import { minTablet } from '../styles/breakpoints';

export const P = styled.p`
  font-size: 18px;
  line-height: 1.4;

  ${minTablet} {
    font-size: 20px;
  }

  margin-top: ${({ gapBefore }) => (gapBefore ? '1em' : 0)};
  margin-bottom: ${({ gapAfter }) => (gapAfter ? '1em' : 0)};
`;



// WEBPACK FOOTER //
// ./src/components/P/P.js